import { API_TYPE } from '@umu/umu-fetch';
const BasePath = '/uapi/v1/session';

export const SubTitleAPI = {
    SAVE_SUBTITLE: {
        url: `${BasePath}/upd-ai-subtitle`,
        type: API_TYPE.POST,
    },
    GET_SUBTITLE: {
        url: `${BasePath}/ai-subtitle`,
        type: API_TYPE.POST,
    },
};
